export * from "./did-avatar"
